export const loadGoogleTagManager = () => {
  if (typeof window !== 'undefined') {
    (function (w: Window & Record<string, unknown>, d: Document, s: string, l: string, i: string) {
      const dataLayer = (w[l] || []) as Array<Record<string, unknown>>;
      w[l] = dataLayer;
      dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });
      // eslint-disable-next-line no-var
      var f = d.getElementsByTagName(s)[0] as HTMLScriptElement | undefined,
        j = d.createElement(s) as HTMLScriptElement,
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
      f?.parentNode?.insertBefore(j, f);
    })(
      window as unknown as Window & Record<string, unknown>,
      document,
      'script',
      'dataLayer',
      'GTM-MSX7NS',
    );
  }
};
